var map = {
	"./address.svg": 9795,
	"./appointment-small.svg": 5408,
	"./appointment.svg": 7487,
	"./arrow-right.svg": 9786,
	"./close.svg": 3999,
	"./closed-cycle.svg": 1013,
	"./collect.svg": 4368,
	"./data.svg": 6694,
	"./diagnosis-small.svg": 7310,
	"./diagnosis.svg": 2843,
	"./email.svg": 1262,
	"./flow.svg": 9963,
	"./hospital.svg": 3760,
	"./insect.svg": 6017,
	"./laboratory.svg": 4906,
	"./logo-black.svg": 9918,
	"./logo-white.svg": 2453,
	"./manage.svg": 6674,
	"./phone.svg": 7892,
	"./purchase.svg": 2606,
	"./reception-small.svg": 1465,
	"./reception.svg": 2841,
	"./refine.svg": 4741,
	"./saas.svg": 8797,
	"./safe.svg": 1026,
	"./smart.svg": 5542,
	"./stock.svg": 8060,
	"./to-top.svg": 2729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;